import { render, staticRenderFns } from "./GlanceOptionsItem.vue?vue&type=template&id=af5c8da8&scoped=true&"
import script from "./GlanceOptionsItem.vue?vue&type=script&lang=js&"
export * from "./GlanceOptionsItem.vue?vue&type=script&lang=js&"
import style0 from "./GlanceOptionsItem.vue?vue&type=style&index=0&id=af5c8da8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5c8da8",
  null
  
)

export default component.exports